import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {useTranslation} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import {usePageStateSelector} from '../../../hooks/state'
import {getMoreOccurrencesCount, isLastAvailableOccurrence} from '../../../selectors/occurrences'
import cs from '../../classnames.scss'
import {RecurringDatesCountProps} from './interfaces'
import s from './recurring-dates-count.scss'

export const RecurringDatesCount = ({disableSpacing, className}: RecurringDatesCountProps) => {
  const count = usePageStateSelector(getMoreOccurrencesCount)
  const isLastOccurrence = usePageStateSelector(isLastAvailableOccurrence)
  const {t} = useTranslation()

  return (
    <div
      data-hook={DH.eventDetailsFullLocation}
      className={classNames({[s.spacing]: !disableSpacing}, cs.evTextFont, cs.evTextColor, className)}
    >
      {isLastOccurrence ? t('recurring.lastAvailableDate') : t('recurring.moreDatesLabel', {count})}
    </div>
  )
}
